import { type FC } from 'react';
import classnames from 'classnames';
import { adjustFlexBasis } from 'dibs-scroll-carousel/exports/adjustFlexBasis.ts';
import { getGapClassName } from 'dibs-scroll-carousel/exports/getGapClassName.ts';
import { getScrollPaddingClassName } from 'dibs-scroll-carousel/exports/getScrollPaddingClassName.ts';
import { type GapSize } from 'dibs-scroll-carousel/exports/types.ts';
import { type TileSize } from 'dibs-buyer-product-tile/exports/BuyerProductTile.ts';
import { BuyerProductTileShimmer } from 'dibs-buyer-product-tile/exports/BuyerProductTileShimmer.ts';

// styles
import styles from './ItemTilesCarouselShimmer.scss';
import dibsCss from 'dibs-css';

export const ItemTilesCarouselShimmer: FC<{
    fullWidth?: boolean;
    height?: number | string;
    size?: TileSize;
    itemsToShow: number;
    gapSize: GapSize;
    showArrows?: boolean;
}> = ({ fullWidth, height, size, itemsToShow, gapSize, showArrows = false }) => {
    const scrollPadding = fullWidth ? 'small' : 'none';
    const orientation = 'horizontal';

    return (
        <div
            className={classnames(
                {
                    'primary-viewport-width': fullWidth,
                    [styles.arrowSpacing]: showArrows,
                },
                dibsCss.overflowHidden
            )}
        >
            <div
                style={{ height }}
                className={classnames(
                    styles.wrapper,
                    dibsCss.flex,
                    dibsCss.overflowHidden,
                    styles[getGapClassName({ gapSize, orientation })],
                    styles[getScrollPaddingClassName({ scrollPadding, orientation })]
                )}
            >
                {[...Array(Math.ceil(itemsToShow))].map((_, index) => (
                    <div
                        key={index}
                        className={classnames(
                            styles.item,
                            dibsCss.shrink0,
                            styles[getGapClassName({ gapSize, orientation })]
                        )}
                        style={{
                            flexBasis: adjustFlexBasis({
                                scrollPadding,
                                gapSize,
                                itemsToShow,
                            }),
                        }}
                    >
                        {size ? (
                            <BuyerProductTileShimmer key={index} size={size} />
                        ) : (
                            <div
                                className={classnames(styles.shimmer, dibsCss.wFull, dibsCss.hFull)}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
